import React, { useEffect } from "react";
import "./modal.scss";

interface ModalProps extends React.ComponentProps<"div"> {
    children?: React.ReactNode;
    showModal: boolean;
    onClose: () => void;
}

const Modal: React.FC<ModalProps> = (props: ModalProps) => {
    const { children, showModal, ...rest } = props;
    const compClass = "cfmui-modal";

   //  useEffect(() => {
   //      document.body.style.overflow = showModal ? "hidden" : "unset";
   //  }, [props.showModal]);

    const attributes = {
        ...rest,
        className: `${rest.className || ""} ${compClass}`.trim(),
    };
    return (
        <div {...attributes}>
            <div className="cfmui-modal-box">
                <button
                    type="button"
                    className="close-button"
                    onClick={rest.onClose}
                />
                <div className="cfmui-modal-content">{children}</div>
            </div>
        </div>
    );
};

export default Modal;
